import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import IdentityVerificationResults from "../identity_verification_results/IdentityVerificationResults.vue";

export default{
  name: 'VerificationResults',
  components: {NavigationBackButton, IdentityVerificationResults},

  data: () => ({
    active_tab: 'IDV Results',
    tabs: ['IDV Results', 'CPIC Results', 'Directors Results', 'Address search'],
  }),

  methods:{
      set_active_tab(tab) {
      this.active_tab = tab;
    },
  }
}